<template>
    <VerifyOTPInForm></VerifyOTPInForm>
  </template>
  <script>
  import VerifyOTPInForm from "../../components/Auths/VerifyOTP.vue";
  export default {
    name: "Verify OTP",
    components: { VerifyOTPInForm },
  };
  </script>
  